import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@greco-fit/scaffolding';
import { Purchase } from '@greco/sales-purchases';
import { PurchaseService } from '../../services';

@Component({
  templateUrl: './set-referred-by.dialog.html',
})
export class SetPurchaseReferredByDialog implements OnInit {
  constructor(
    private purchaseSvc: PurchaseService,
    @Inject(MAT_DIALOG_DATA) private purchase: Purchase,
    private matDialogRef: MatDialogRef<SetPurchaseReferredByDialog>
  ) {
    this.accountId = purchase.account.id;
  }

  readonly simpleDialogData: DialogData = {
    title: 'Referred by',
    subtitle: "Update the 'Referred by' property of this purchase with an existing user email.",
    hideDefaultButton: true,
  };

  soldByFormControl = new FormControl(null);

  accountId: string;

  cancel() {
    this.matDialogRef.close();
  }

  async submit() {
    try {
      const update = await this.purchaseSvc.setReferredBy(
        this.purchase.id,
        this.soldByFormControl.value?.email ?? null
      );
      this.matDialogRef.close(update);
    } catch (err) {
      console.error(err);
    }
  }

  ngOnInit() {
    setTimeout(() => this.soldByFormControl.reset(this.purchase.referredBy));
  }
}
